module.exports = __webpack_public_path__ + "static/img/indexImg2.1a47816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexImg2.jpg
// module id = Rvd8
// module chunks = 3